// extracted by mini-css-extract-plugin
export default {"bottom-sheet-title":"bottom-sheet-title__BwJmO","bottom-sheet-items":"bottom-sheet-items__+U+pJ"};